// Admin upload: the guest uploader pointed at any category — this is the UI path
// for fotobox/photographer batches (the import script covers server-side drops).
import React, { useEffect, useState } from 'react';
import { api } from '../api.js';
import Uploader from '../components/uploader.jsx';
import { toast } from '../components/toast.jsx';

export default function AdminUpload() {
	const [categories, setCategories] = useState([]);
	const [current, setCurrent] = useState('');

	useEffect(() => {
		api.categories()
			.then((cats) => {
				setCategories(cats);
				setCurrent((cur) => cur || cats[0]?.id || '');
			})
			.catch(() => toast('Kategorien konnten nicht geladen werden.', 'error'));
	}, []);

	return (
		<section className='adminupload'>
			<label className='adminupload__label' htmlFor='admin-upload-category'>
				Zielkategorie
			</label>
			<select id='admin-upload-category' className='input adminupload__select' value={current} onChange={(e) => setCurrent(e.target.value)}>
				{categories.map((c) => (
					<option key={c.id} value={c.id}>
						{c.name}
					</option>
				))}
			</select>
			{/* key remounts the uploader on category switch so state never leaks across */}
			{current && <Uploader key={current} category={current} />}
		</section>
	);
}
